export const createFeatureLoader = loader => (url, format, onSuccess, onError = () => {}) => {
  function featureLoader(extent, resolution, projection) {
    const urlWithParams = typeof url === 'function' ? url.call(this, extent, resolution, projection) : url;
    return loader(urlWithParams).then(response => {
      const type = format.getType();

      if (type === "json") {
        return response.json();
      }

      return response.text();
    }).then(source => {
      if (!source) {
        return null;
      }

      const features = format.readFeatures(source, {
        extent,
        featureProjection: projection
      });
      return onSuccess.call(this, features);
    }).catch(e => {
      if (e.code === 20) {
        // Do nothing if request was aborted, message: 'The user aborted a request.'
        return;
      }

      onError.call(this);
    });
  }

  return featureLoader;
};
export const createImageLoader = loader => (tile, tileUrl) => {
  loader(tileUrl).then(response => {
    if (typeof response === 'string') {
      return response;
    }

    if (response instanceof Blob) {
      return URL.createObjectURL(response);
    }

    return response.blob().then(blob => URL.createObjectURL(blob));
  }).then(imgUrl => {
    // eslint-disable-next-line no-param-reassign
    tile.getImage().src = imgUrl;
  });
};
export const createVectorTileLoader = loader => (tile, url) => {
  const format = tile.getFormat();
  const tileLoader = createFeatureLoader(loader)(url, format, tile.onLoad, tile.onError);
  tile.setLoader(tileLoader);
};
export const createVectorSourceLoader = loader => (url, format) => {
  function onSuccess(features) {
    this.addFeatures(features);
  }

  return createFeatureLoader(loader)(url, format, onSuccess);
};